export interface HomepageSeo {
	title: ComputedRef<string>;
	description: ComputedRef<string>;
}

export function useHomepageSeo(): HomepageSeo {
	const title = computed(
		() => 'O endereço dos melhores endereços | PilarHomes'
	);
	const description = computed(
		() =>
			'Encontre casas e apartamentos à venda nos melhores endereços de São Paulo e Curitiba no PilarHomes. Explore mais de 20 mil imóveis de alto padrão.'
	);

	return {
		title,
		description
	};
}
